import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faCartShopping,
  faBars,
  faSearch,
  faSignIn,
  faSignOut,
  faGavel,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as farHeart,
  faUserCircle,
} from "@fortawesome/free-regular-svg-icons";
import Logo from "../../components/Logo";
// hooks
import useAuth from "../../hooks/useAuth";
import useCategories from "../../hooks/useCategories";
// components
// //
import { MenuItems } from "./MenuItems";
import NavItems from "./NavItems";
import logoWhite from "../../assets/img/logo-white.png";
import svg from "../../assets/img/svg/cancel.svg";
// import svgsearch from "../../assets/img/svg/search.svg";
import { NotificationContext } from "../../contexts/NotificationContext";
import { WishListContext } from "../../contexts/WishListContext";
import { CartContext } from "../../contexts/CartContext";
import {
  CartShow,
  NotificationShow,
  WishListShow,
} from "../../components/OffCanvas";
import SocialLinks from "../SocialLinks";
import { CompareContext } from "./../../contexts/CompareContext";
import { CompareShow } from "./../../components/OffCanvas/Compare/CompareShow";
import "./Navbar.css";
import { SubNavbar } from "./SubNavbar";
import { MobileViewButtons } from "./MobileViewButtons";
import { currencySymbol } from "../../utils/helpers";
import CurrencyFormat from "react-currency-format";
// ----------------------------------------------------------------------

export default function MainNavbar({
  renderSearchBar,
  handelSearchCategoryChange,
  setSearchKeyword,
  searchKeyword,
  handleSearch,
  search,
  searchedItems,
  isGlobalSearchLoading,
  handelSearchedItemSelection,
  isSearchDropdownVisible,
  hideSearchDropdown,
}) {
  const { isAuthenticated, user, logout } = useAuth();
  const { headerCategories } = useCategories();
  let navigate = useNavigate();
  const globalSearchDropdownRef = useRef(null);
  const [click, setClick] = useState(false);

  // const [searchKeyword, setSearchKeyword] = useState(null);
  // this hooks use search btn show
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  // this hooks use notification show btn
  const [showNotification, setShowNotification] = useState(false);

  const handleClosNotification = () => setShowNotification(false);
  const handleShowNotification = () => setShowNotification(true);
  // this hooks use Shoping cart show btn
  const [showCart, setShowCart] = useState(false);

  const handleClosCart = () => setShowCart(false);
  const handleShowCart = () => setShowCart(true);

  // this hooks use wishlist show btn
  const [showWishList, setShowWishList] = useState(false);

  //Compare the products
  const [showCompare, setShowCompare] = useState(false);
  const handleCloseCompare = () => setShowCompare(false);
  const handleShowCompare = () => setShowCompare(true);
  const [compareForContext, setCompareForContext] = useContext(CompareContext);

  const handleCloseWishList = () => setShowWishList(false);
  const handleShowWishList = () => setShowWishList(true);

  const [notificationList, setNotification] = useContext(NotificationContext);
  const [wishlistsForContext, setWishlistsForContext] =
    useContext(WishListContext);
  const [cartList, setCartList] = useContext(CartContext);

  // const handleSearch = (e) => {
  //   const {name, value} = e.target;
  //   setSearchKeyword(value);
  // };

  // const search = () => {
  //   if (searchKeyword !== null ) {
  //     navigate(`/mobiles?keyword=${searchKeyword}`);
  //     window.location.reload();
  //   }
  // }
  const handleabout = () => {
    if (click) {
      document.querySelector("#offcanvas-about").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#offcanvas-about").style =
        "transform: translateX(0%);";
    }
    setClick(!click);
  };

  const handleMenu = () => {
    if (click) {
      document.querySelector("#mobile-menu-offcanvas").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#mobile-menu-offcanvas").style =
        "transform: translateX(0%);";
    }
    setClick(!click);
  };

  const handleShow = (value) => {
    value === show ? setShow("") : setShow(value);
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  //To hide search dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        globalSearchDropdownRef.current &&
        !globalSearchDropdownRef.current.contains(event.target)
      ) {
        hideSearchDropdown();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [hideSearchDropdown]);

  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    scrollTop >= 250
      ? header?.classList?.add("is-sticky")
      : header?.classList?.remove("is-sticky");
  };

  const handleLogout = async () => {
    await logout();
    // Swal.fire({
    //   text: "Logged out successfully!",
    //   icon: "success",
    // });
    navigate("/auth/login");
    window.location.reload();
  };
  // console.log({searchKeyword});
  return (
    <>
      <header id="header" className="sticky-top">
        <div className="header_top border-bottom d-lg-block d-none">
          <nav className="navbar navbar-expand-lg bg-white py-3">
            <div className="container">
              <div className="col-xl-3 col-lg-3 col-md-12">
                <RouterLink
                  to="/"
                  className="navbar-brand d-lg-block d-none mr-20"
                >
                  {/* <img src={logo} alt="logo" /> */}
                  <Logo />
                </RouterLink>
                {/* <a className="navbar-brand d-lg-block d-none" href="index.html">
                          <img src="img/logo.png" width="180" alt=""/>
                        </a> */}
              </div>
              <div className="col-xl-5 col-lg-5 col-md-6">
                <form action="#" className="search_block">
                  <div className="input-group w-100">
                    <select
                      className="form-select custom_select border-end"
                      aria-label="Category Select"
                      onChange={handelSearchCategoryChange}
                      defaultValue={"All"}
                    >
                      <option value="All">All</option>
                      {/* {
                        headerCategories && headerCategories?.map((h, i) => {
                          return (
                            <option key={i} value={h.slug}>{h.title}</option>
                          )
                        })
                      } */}
                      <option value="Mobiles">Mobiles</option>
                      <option value="Laptops">Laptops</option>
                    </select>
                    <input
                      type="text"
                      onChange={handleSearch}
                      value={searchKeyword}
                      className="form-control"
                      placeholder="Enter a keyword to search products"
                    />
                    <Link
                      to="#!"
                      className="upload_search"
                      data-bs-toggle="modal"
                      data-bs-target="#SearchByImage"
                    >
                      <i data-feather="camera"></i>
                    </Link>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={search}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </form>
                {isSearchDropdownVisible && (
                  <div
                    className="global_search_div"
                    ref={globalSearchDropdownRef}
                  >
                    <ul>
                      {searchedItems?.length > 0 ? (
                        searchedItems.map((data, index) => (
                          <li key={index}>
                            <Link
                              to="#!"
                              className="search_item"
                              onClick={() =>
                                handelSearchedItemSelection(data?.title)
                              }
                            >
                              <div className="item_image">
                                {data.variant_image ? (
                                  <img src={data?.variant_image.url} alt="" />
                                ) : (
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/placeholder-images.png`}
                                    alt=""
                                  />
                                )}
                              </div>
                              <div className="item_description">
                                <span>{data?.title}</span>
                                <p className="item_sub_description">
                                  {data?.attributes.replace(/['"]+/g, "")}
                                </p>
                              </div>
                              <div className="item_price">
                                {currencySymbol()}{" "}
                                {data.price && (
                                  <CurrencyFormat
                                    value={data.price}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                  />
                                )}
                              </div>
                            </Link>
                          </li>
                        ))
                      ) : isGlobalSearchLoading ? (
                        <li>
                          <div className="item_description">Searching</div>
                        </li>
                      ) : (
                        <li>
                          <div className="item_description">
                            No record found
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="NavList NavRightBlock d-xl-flex d-lg-flex d-md-flex d-none justify-content-end">
                  <div className="NavAcLeft d-flex me-0">
                    <div className="navlist_btn text-center">
                      {user?.user_type === "3" && (
                        <Button
                          variant=""
                          className="header_pd"
                          onClick={handleShowWishList}
                        >
                          <i className="fas fa-heart"></i>
                          <sup>{wishlistsForContext?.length}</sup>
                        </Button>
                      )}
                    </div>
                    <div className="navlist_btn">
                      {user?.user_type === "3" && (
                        <Button
                          variant=""
                          className="header_pd"
                          onClick={handleShowCompare}
                        >
                          <i className="fas fa-exchange-alt"></i>
                          <sup>{compareForContext.length}</sup>
                        </Button>
                      )}
                      {/* <a href="compare.html" className="header_pd" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Compare"><i className="fas fa-sync-alt"></i></a> */}
                    </div>
                    <div className="navlist_btn">
                      {user?.user_type === "3" && (
                        <Button
                          variant=""
                          className="header_pd"
                          onClick={handleShowCart}
                        >
                          <i className="fas fa-shopping-cart"></i>
                          <sup>{cartList?.length}</sup>
                        </Button>
                      )}
                      {/* <a className="header_pd" data-bs-toggle="offcanvas" href="#CartOffcanvas" role="button" aria-controls="CartOffcanvas"><i className="fas fa-shopping-cart"></i><sup>9+</sup></a> */}
                    </div>
                    <div className="navlist_btn">
                      {user?.user_type === "3" && (
                        <Link to="/requested-quotes" className="header_pd">
                          <i className="fas fa-gavel"></i>
                        </Link>
                      )}
                      {/* <a className="header_pd" data-bs-toggle="offcanvas" href="#CartOffcanvas" role="button" aria-controls="CartOffcanvas"><i className="fas fa-hammer"></i><sup>9+</sup></a> */}
                    </div>
                  </div>
                  <div className="NavAcRight">
                    {isAuthenticated ? (
                      <div className="dropdown Aftersignin">
                        <Link
                          className="btn dropdown-toggle"
                          to="#"
                          role="button"
                          id="dropdownMenuLink"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="far fa-user"></i>
                          <span className="pe-20">
                            {user?.user_type === "4"
                              ? user?.name
                              : user?.first_name}{" "}
                          </span>
                        </Link>

                        <ul
                          className="dropdown-menu dropdown-menu-end"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <li>
                            <h6 className="dropdown-header">
                              <i className="fas fa-user me-2"></i>{" "}
                              {user?.user_type === "4"
                                ? user?.name
                                : user?.first_name}{" "}
                            </h6>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={
                                (user?.user_type === "4" && "/financer/profile")
                                  ||
                                 ("/user/profile")
                              }
                            >
                              My Profile
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={
                                (user?.user_type === "2" && "/supplier") ||
                                (user?.user_type === "4" && "/financer") ||
                                "/dashboard"
                              }
                            >
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link
                              role="button"
                              onClick={() => {
                                handleLogout();
                              }}
                              className="dropdown-item"
                              to="#!"
                            >
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <>
                        {/* <div className="navlist_btn me-0" title="Sign In">
                        <Link to="/auth/login" className="btn btn-primary me-2">
                         Sign In
                        </Link>
                        or
                        <a href="/auth/select-user-type" className="btn btn-primary ms-2">
                          Sign Up
                        </a>
                      </div> */}
                        <div className="dropdown login_btn">
                          <button
                            className="btn btn-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Sign in / Join
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <Link
                                className="dropdown-item btn"
                                to="/auth/login"
                              >
                                <i className="fas fa-sign-in-alt me-1"></i> Sign
                                In
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item btn"
                                to="/auth/select-user-type"
                              >
                                <i className="far fa-user me-1"></i> Join Free
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                  {/* <Link to="#!" className="btn btn-success"><i className="fa-solid fa-wallet me-1"></i> Start Selling</Link> */}
                </div>
              </div>
            </div>
          </nav>
        </div>
        <MobileViewButtons
          handleShowWishList={handleShowWishList}
          handleShowCompare={handleShowCompare}
          handleShowCart={handleShowCart}
        />
        {/* <SubNavbar
          categories={headerCategories}
          setSearchKeyword={setSearchKeyword}
          handleSearch={handleSearch}
          search={search}
        /> */}
      </header>
      <CartShow
        showCart={showCart}
        onHideCart={handleClosCart}
        placement={"end"}
      />

      <WishListShow
        wishlistsForContext={wishlistsForContext}
        showWishList={showWishList}
        handleCloseWishList={handleCloseWishList}
        placement={"end"}
      />

      <CompareShow
        showCompare={showCompare}
        handleCloseCompare={handleCloseCompare}
        placement={"end"}
      />
    </>
  );
}
